import { Link } from 'react-router-dom';

import { Box, Button, Flex, Text } from '@spotify-internal/encore-web';
import {
  AuthScreen,
  ConfidenceWebsiteLinkEncore,
} from '@spotify/confidence-core-react';
import { useFeatureFlag } from '@spotify/confidence-flag-evaluation-react';

import styles from './WelcomeScreen.module.css';

type WelcomeScreenProps = {
  variant: 'a' | 'b';
  onContinue: () => void;
};

export const WelcomeScreen = ({ variant, onContinue }: WelcomeScreenProps) => {
  const { enabled: freeEmailSignupEnabled } = useFeatureFlag<{
    enabled: boolean;
  }>('signup-free-email', { enabled: false });

  return (
    <AuthScreen.Root>
      <AuthScreen.Main>
        <Flex
          className={styles.content}
          direction="column"
          gap="looser-3"
          alignItems="center"
        >
          <Link to="/" aria-label="Go to homepage" data-track-source-anchor="f247075383">
            <AuthScreen.Logo />
          </Link>
          <Flex direction="column" gap="tighter-3" alignItems="center">
            <AuthScreen.Title>Let&apos;s create your account</AuthScreen.Title>
            <AuthScreen.Description>
              {variant === 'a' ? (
                <>
                  {freeEmailSignupEnabled
                    ? 'Use your work email to make it easier for teammates to join your workspace.'
                    : 'Use your work email, so your teammates can be in the same workspace.'}
                  <br />
                  Free to start, no credit card needed.
                </>
              ) : (
                'Free to start, no credit card needed.'
              )}
            </AuthScreen.Description>
          </Flex>
          <Flex direction="column" gap="tighter" alignItems="center">
            <Button
              variant="primary"
              colorSet="inverted"
              size="large"
              className={styles.button}
              data-testid="signup-continue"
              onClick={onContinue}
             data-track-source-anchor="6b6abe73d4">
              Continue
            </Button>
            <Box paddingBlockStart="tighter-2">
              <Text variant="bodySmall" semanticColor="textSubdued" as="div">
                For more info on how Spotify handles your data, check out our{' '}
                <ConfidenceWebsiteLinkEncore
                  route="/privacy-policy"
                  className={styles.privacyLink}
                >
                  Privacy Policy
                </ConfidenceWebsiteLinkEncore>
                .
              </Text>
            </Box>
          </Flex>
        </Flex>
      </AuthScreen.Main>
    </AuthScreen.Root>
  );
};
